import React from 'react';
import { Link } from 'react-router-dom';
import {FaSquareFacebook, FaSquareInstagram, FaSquareYoutube, FaLinkedin} from 'react-icons/fa6'
import '../styles/Footer.css';


export default function Footer() {
  return (
    <div className='footer-container'>
        <div className='footer-top'>
            <div className='footer-logo-container'>
                <img src={process.env.PUBLIC_URL + '/assets/footer_logo.png'} className='navbar-logo'/>
            </div>
            <div className='footer-items'>
                <div className='footer-items-header'> Find Us</div>
                <div className='footer-item'> 67 Picton Street</div>
                <div className='footer-item'>Newtown</div>
                <div className='footer-item'>Port-of-Spain</div>
                <div className='footer-item'>Trinidad</div>
            </div>
            <div className='footer-items'>
                <div className='footer-items-header'> Key Links</div>
                <div className='footer-item'>CANTO Mission and Vision</div>
                <div className='footer-item'> CANTO Overview</div>
                <div className='footer-item'>CANTO Opportunities</div>
                <div className='footer-item'>CANTO News</div>
                <Link to='/privacy-policy' className='footer-item footer-link'>Privacy Policy</Link>
            </div>
            <div className='footer-items'>
                <div className='footer-items-header'> Key Links</div>
                <div style={{display: 'flex', width: '100%'}}>
                    <a href='https://www.facebook.com/CANTO.ICT' target='_blank'>
                        <FaSquareFacebook size={24} className='footer-icon' />
                    </a>
                    <a href='https://www.instagram.com/canto_caribbean/?hl=en' target='_blank'>
                        <FaSquareInstagram size={24} className='footer-icon'/>
                    </a>
                    <a href='https://www.youtube.com/channel/UCKPbSWepwVcn4L2RK-HrPuA' target='_blank'>
                        <FaSquareYoutube size={24}className='footer-icon' />
                    </a>
                    <a href='https://www.linkedin.com/company/canto-caribbean/' target='_blank'>
                        <FaLinkedin size={24} className='footer-icon'/>
                    </a>
                </div>
            </div>

            <div>

            </div>
        </div>
        <div className='footer-bottom'>Copyright © CANTO 2024</div>
    </div>
  )
}
